(() => {
  'use strict';

  const PROGRESS = {
    welcome: 0,
    name: 6,
    age: 14,
    pregnancy: 22,
    skin: 31,
    climate: 40,
    sensitivity: 52,
    allergy: 70,
    barrier: 68,
    goal: 76,
    antiage: 90,
    spots: 90,
    acne: 90,
    pores: 90,
    email: 96,
    results: 100
  };

  const SCREEN_LABELS = {
    welcome: 'Comenzar',
    name: 'Tu nombre',
    age: 'Rango de edad',
    pregnancy: 'Seguridad',
    skin: 'Tipo de piel',
    climate: 'Clima',
    sensitivity: 'Sensibilidad',
    allergy: 'Alergias',
    barrier: 'Barrera cutánea',
    goal: 'Objetivo',
    antiage: 'Signos de la edad',
    spots: 'Tipo de manchas',
    acne: 'Tipo de acné',
    pores: 'Tipo de poros',
    email: 'Recibir tu rutina',
    results: 'Resultados'
  };

  const LABELS = {
    age: {
      under20: 'Menos de 20',
      '20to30': '20–30 años',
      '30to40': '30–40 años',
      '40to50': '40–50 años',
      '50to60': '50–60 años',
      '60plus': '60+ años'
    },
    pregnancy: { pregnant: 'Embarazo', lactating: 'Lactancia', no: 'Sin restricción por embarazo' },
    skin: { normal: 'Piel normal', oily: 'Piel grasa', dry: 'Piel seca', combination: 'Piel mixta', sensitive: 'Piel sensible' },
    climate: { humid_hot: 'Clima húmedo y cálido', dry_hot: 'Clima seco y cálido', temperate: 'Clima templado', cold_dry: 'Clima frío y seco', variable: 'Clima variable' },
    goal: { acne: 'Brotes o acné', spots: 'Manchas', antiage: 'Arrugas y firmeza', hydration: 'Hidratación', pores: 'Poros' }
  };

  const IMAGES = {
    postAcne: 'https://cdn.shopify.com/s/files/1/0614/6431/3900/files/quiz-hW_HilsE2XfGE26Gwr-0hECZF_X569oJBQlocICNdb8vbygxkFITK2tUc1k4cUx2YkqBqS5mz1JqgMWJWXB6cXQt4qWdIc4tsb3wEt35LLjFGn6J8PGYDovbco205d4LNs6WAMyZIuQbArSQo-HGuF1H_J-Gd5GZOMP02H6XwwKRCwVr7F.jpg?v=1777750153',
    melasma: 'https://cdn.shopify.com/s/files/1/0614/6431/3900/files/quiz-Melasmablemish.jpg?v=1777750007',
    solar: 'https://cdn.shopify.com/s/files/1/0614/6431/3900/files/quiz-images_a2fe34ad-3eef-4f47-8212-89924a8714e4.jpg?v=1777750054',
    redness: 'https://cdn.shopify.com/s/files/1/0614/6431/3900/files/quiz-COi0oKgFixutfnT052BY-PDl8Opf0kTAsz4Hz5uF1NBAYy8aVo1MuzrAeeH2IgELMsGDcDVBzbKwMMAvKwxUgOMnI5k-4kS-1vxQvTwfUetYGeJuAwP-oKBAw5aIWFIIRNPqa2TVhrewvwIYGKq4duF9KK96TiUWZbf3wRYUDpkZ-ME-VC.jpg?v=1777750313',
    ageSpots: 'https://cdn.shopify.com/s/files/1/0614/6431/3900/files/quiz-XeFcAqI87ZAwDixknCh1QnAp2gXHDmhOwVRkAxetGBx1n5OLQMM-_85Xk-0Ra2R6zhbwRbvGJZ2qZxc0NI3jos3_HWuruj1CFT8-Q7F60G3kkS4LrFvMRqmMkJAFo9MwPdEvqKBHEBdCHV8z4njCHPNOnm3DKHk32R1xAFOFmsG4ucZ9Lp.jpg?v=1777750245',
    comedonal: 'https://cdn.shopify.com/s/files/1/0614/6431/3900/files/quiz-NvFvjSs0h_FW5C59D7bBIuoJ1YNB4zTUZUTU_Hg7Hp5utChTmHIxc6ePwMHr0uXBCcO5M26ebzhXf6Cd3fOaUncupxYHwP3US0F0RNQ3lIf64oramr14xbHZlGGoFMZUvNw9Kh60PAWo2EnRWl4kF0yc1We-RMPscV-kGsJOrst9GhAcOY.jpg?v=1777783447',
    inflammatory: 'https://cdn.shopify.com/s/files/1/0614/6431/3900/files/quiz-9X5GQekeiihh7NWODUttZB4rOGebF4wjqNaJ14xORiboy6_Sy9rDyVErG0ke8kb1fQyMVDKh12juJCnSJ1YXzR6zd8JRv7fgaFRODis3kdj88bUUgIsVSX_r9qeo2_YweqsaiHAikM4oGuiG2_s6lk1JnD_G9gPBnpfTtZzcf7Hrqk3VKG.jpg?v=1777783578',
    hormonal: 'https://cdn.shopify.com/s/files/1/0614/6431/3900/files/quiz-dRiFn5h9DrTAKRq7PQwoqAOg5Ol2Cy2CrYD25DwWgeeUxOO30dkgVmx3TQMn5CjdXfxobaoGklFsmC686dDLoJ_rrYbgmuUsMSSQA13jeZzegAiDYx1ppUC1LRicAlsAROsYS4hXkgUT2PCp4kyToZMaSxk_kDaxJlfbZVt0HNyiMMuSbG.jpg?v=1777783532',
    cystic: 'https://cdn.shopify.com/s/files/1/0614/6431/3900/files/quiz-LSddOqsVYQley-woztcpqBl7uUf1INU2xUhvyovitf6pamOI4VInLDFgBn2vFxSwL6k0NHN1B59BpDTktQNm-xQnbHDEiRZAl-V3WBk3iJ-XqOMtthUH5swBS0s9AcyEDtiraTF-0DWu0gpr7KjosFOy75ZMzc7eOv1ZL4Qg9GJVb2xeUk.jpg?v=1777783507',
    poresOil: 'https://cdn.shopify.com/s/files/1/0614/6431/3900/files/quiz-poros-dilatados.webp?v=1777846867',
    poresClogged: 'https://cdn.shopify.com/s/files/1/0614/6431/3900/files/quiz-porosobstruidos.webp?v=1777846848',
    poresElasticity: 'https://cdn.shopify.com/s/files/1/0614/6431/3900/files/quiz-poroselasticidad.jpg?v=1777846896',
    poresDehydration: 'https://cdn.shopify.com/s/files/1/0614/6431/3900/files/quiz-porosdeshidratados.jpg?v=1777846923'
  };

  const SCREENS = {
    age: {
      eyebrow: 'Sobre tu piel',
      title: '¿Cuál es tu rango de edad?',
      lead: 'La edad influye en la producción de grasa, colágeno y elasticidad.',
      options: [
        ['under20', 'Menos de 20 años'], ['20to30', '20 a 30 años'], ['30to40', '30 a 40 años'],
        ['40to50', '40 a 50 años'], ['50to60', '50 a 60 años'], ['60plus', '60 años o más']
      ]
    },
    pregnancy: {
      eyebrow: 'Seguridad',
      title: '¿Estás embarazada o en período de lactancia?',
      lead: 'Usaremos esta respuesta para excluir retinoides y productos etiquetados como no aptos.',
      options: [['pregnant', '🤰 Sí, estoy embarazada'], ['lactating', '🍼 Estoy en etapa de lactancia'], ['no', 'No']]
    },
    skin: {
      eyebrow: 'Tipo de piel',
      title: '¿Cómo luce tu piel al despertar?',
      lead: 'Piensa en tu piel antes de lavarla o aplicar cualquier producto.',
      options: [
        ['normal', 'Equilibrada', 'Ni grasosa ni seca'],
        ['oily', 'Grasa', 'Se ve brillante o grasosa'],
        ['dry', 'Seca', 'Se siente reseca o tirante'],
        ['combination', 'Mixta', 'Grasa en frente y nariz (zona T)'],
        ['sensitive', 'Sensible', 'Rojiza o con zonas irritadas']
      ]
    },
    climate: {
      eyebrow: 'Tu entorno',
      title: '¿En qué tipo de clima vives normalmente?',
      lead: 'Esto ayuda a priorizar texturas más ligeras o más nutritivas.',
      options: [['humid_hot', '🌤️ Húmedo y caluroso'], ['dry_hot', '☀️ Seco y caluroso'], ['temperate', '🌿 Templado'], ['cold_dry', '❄️ Frío y seco'], ['variable', '🔄 Cambia con frecuencia']]
    },
    sensitivity: {
      eyebrow: 'Sensibilidad y barrera',
      title: '¿Cómo sientes tu piel al probar productos?',
      lead: 'Esto define si conviene priorizar una rutina calmante y reparadora.',
      options: [
        ['resistant', 'Mi piel es resistente', 'Casi nada me irrita'],
        ['rosacea', 'Tendencia a rojez o rosácea', 'Sensibilidad constante'],
        ['weather_reactive', 'Reacciona al clima', 'Se pone roja o pica con frío, calor o viento'],
        ['active_reaction', 'Está reaccionando ahora', 'Un producto nuevo me irritó'],
        ['damaged_barrier', 'Barrera dañada', 'Muy tirante, pelada o lastimada'],
        ['allergy', 'Tengo alergias conocidas', 'A ingredientes cosméticos']
      ]
    },
    barrier: {
      eyebrow: 'Recomendación importante',
      title: 'Tu piel necesita sanar primero 💛',
      lead: 'Cuando la barrera está comprometida, tratar manchas o arrugas con activos fuertes puede aumentar la irritación.',
      options: [
        ['recover', 'Recuperar mi barrera primero', 'Rutina suave, calmante y reparadora', null, null, 'Recomendado'],
        ['continue', 'Seguir con mis otros objetivos', 'Mostraremos advertencias y excluiremos retinoides']
      ]
    },
    goal: {
      eyebrow: 'Paso final',
      title: '¿En qué objetivo quieres que nos enfoquemos hoy?',
      lead: 'Elige la preocupación principal de tu piel.',
      options: [
        ['acne', '🫧 Controlar brotes o acné'], ['spots', '✨ Aclarar manchas o unificar el tono'],
        ['antiage', '⌛ Tratar arrugas o pérdida de firmeza'], ['hydration', '💧 Hidratación profunda y efecto glass skin'],
        ['pores', '🧴 Mejorar la apariencia de los poros']
      ]
    },
    antiage: {
      eyebrow: 'Signos de la edad',
      title: '¿Qué es lo que más te preocupa?',
      lead: 'Diferenciamos el tratamiento de signos visibles de la prevención.',
      options: [['visible', 'Arrugas, flacidez o piel más suelta'], ['prevent', 'Quiero prevenir signos de envejecimiento'], ['none', 'No tengo signos visibles todavía']]
    },
    spots: {
      eyebrow: 'Tipo de manchas',
      title: 'Cuéntanos un poco más sobre tus manchas',
      lead: 'Elige la imagen y descripción que más se parezca a tu caso.',
      picture: true,
      options: [
        ['post_acne', 'Manchas café u oscuras', 'Post-acné', IMAGES.postAcne, 'Ejemplo de manchas oscuras posteriores al acné'],
        ['melasma', 'Melasma', 'Manchas simétricas', IMAGES.melasma, 'Ejemplo visual de melasma'],
        ['solar', 'Manchas solares', 'Pecas', IMAGES.solar, 'Ejemplo de manchas solares'],
        ['redness', 'Irritación o rojez', '', IMAGES.redness, 'Ejemplo de irritación y rojez'],
        ['age_spots', 'Manchas por la edad', '', IMAGES.ageSpots, 'Ejemplo de manchas por la edad']
      ]
    },
    acne: {
      eyebrow: 'Brotes y acné',
      title: '¿Qué tipo de brotes presentas?',
      lead: 'Elige la opción que mejor describe lo que observas.',
      picture: true,
      four: true,
      options: [
        ['comedonal', 'Acné comedogénico', 'Puntos negros o textura áspera, sin inflamación', IMAGES.comedonal, 'Ejemplo de acné comedogénico'],
        ['inflammatory', 'Acné inflamatorio', 'Granitos rojos, sensibles o con pus', IMAGES.inflammatory, 'Ejemplo de acné inflamatorio'],
        ['hormonal', 'Acné hormonal', 'Brotes cíclicos en mentón o mandíbula', IMAGES.hormonal, 'Ejemplo de acné hormonal'],
        ['cystic', 'Acné quístico o severo', 'Granos profundos, duros o dolorosos', IMAGES.cystic, 'Ejemplo de acné quístico o severo']
      ]
    },
    pores: {
      eyebrow: 'Textura y poros',
      title: '¿Cómo describirías la apariencia de tus poros?',
      lead: '',
      picture: true,
      four: true,
      options: [
        ['oil', 'Por exceso de grasa', 'Grandes y con brillo', IMAGES.poresOil, 'Ejemplo de poros visibles por exceso de grasa'],
        ['clogged', 'Poros obstruidos', 'Puntos negros o blancos', IMAGES.poresClogged, 'Ejemplo de poros obstruidos'],
        ['elasticity', 'Falta de elasticidad', 'Se ven alargados', IMAGES.poresElasticity, 'Ejemplo de poros alargados por falta de elasticidad'],
        ['dehydration', 'Falta de hidratación', 'Piel seca o tirante', IMAGES.poresDehydration, 'Ejemplo de poros visibles por deshidratación']
      ]
    }
  };

  const ROUTES = {
    age: () => 'pregnancy',
    pregnancy: () => 'skin',
    skin: () => 'climate',
    climate: () => 'sensitivity',
    sensitivity: (value) => value === 'resistant' ? 'goal' : (value === 'allergy' ? 'allergy' : 'barrier'),
    barrier: (value) => value === 'recover' ? 'email' : 'goal',
    goal: (value) => ({ acne: 'acne', spots: 'spots', antiage: 'antiage', hydration: 'email', pores: 'pores' })[value],
    antiage: () => 'email',
    spots: () => 'email',
    acne: () => 'email',
    pores: () => 'email'
  };

  const CATEGORIES = [
    {
      id: 'oil_cleanser', group: 'cleanse', title: 'Limpiador en aceite',
      description: 'Retira maquillaje, protector solar y residuos oleosos.',
      tags: ['limpiador de aceite', 'limpiador a base de aceite', 'agua micelar'],
      collectionHandles: ['limpiador-de-aceite'],
      excludeTerms: ['jabon facial', 'foam cleanser', 'gel cleanser', 'body wash', 'jabon corporal'],
      essential: false, limit: 1
    },
    {
      id: 'water_cleanser', group: 'cleanse', title: 'Limpiador a base de agua',
      description: 'Segundo paso de la doble limpieza: retira impurezas y exceso de grasa.',
      tags: ['limpiador facial', 'limpiador a base de agua', 'jabon facial', 'jabon'],
      collectionHandles: ['jabon', 'limpiadores'],
      titleTerms: ['cleanser', 'cleansing foam', 'foam cleanser', 'gel cleanser', 'facial wash', 'jabon facial', 'limpiador facial'],
      excludeTerms: ['cleansing oil', 'oil cleanser', 'aceite limpiador', 'limpiador de aceite', 'cleansing balm', 'balsamo limpiador', 'agua micelar', 'body wash', 'jabon corporal'],
      essential: true, limit: 1
    },
    {
      id: 'exfoliant', group: 'prepare', title: 'Exfoliante',
      description: 'Ayuda con textura y células muertas; empieza gradualmente.',
      tags: ['exfoliante', 'exfoliantes', 'exfoliante suave'],
      collectionHandles: ['exfoliante', 'exfoliantes', 'exfoliante-suave'],
      excludeCollectionHandles: ['mascarilla', 'mascarillas', 'mascarilla-de-velo'],
      excludeTerms: ['sheet mask', 'mascarilla de velo'],
      essential: false, limit: 1, strong: true
    },
    {
      id: 'mask', group: 'prepare', title: 'Mascarilla',
      description: 'Cuidado complementario para usar algunas veces por semana.',
      tags: ['mascarillas'], requireTags: ['mascarillas'],
      collectionHandles: ['mascarillas'],
      excludeCollectionHandles: ['mascarilla-de-velo'],
      excludeTerms: ['granitos', 'textura sheet mask', 'vital mask', 'master'],
      essential: false, limit: 1
    },
    {
      id: 'toner', group: 'prepare', title: 'Tónico',
      description: 'Equilibra y prepara la piel para los pasos siguientes.',
      tags: ['tonico'], collectionHandles: ['tonico'],
      excludeCollectionHandles: ['mist'],
      excludeTerms: ['exfoliante', 'exfoliantes', 'exfoliacion suave', 'exfoliante quimico', 'mist'],
      essential: false, limit: 1
    },
    {
      id: 'essence', group: 'prepare', title: 'Esencia',
      description: 'Aporta hidratación profunda y apoyo a la barrera.',
      tags: ['esencia', 'esencias'], collectionHandles: ['esencia', 'esencias'],
      essential: false, limit: 1
    },
    {
      id: 'serum', group: 'treat', title: 'Sérum',
      description: 'Trata tu preocupación principal con ingredientes concentrados.',
      tags: ['serum', 'ampoule', 'ampolla'], collectionHandles: ['serum'],
      excludeCollectionHandles: ['limpiadores', 'limpiador-de-aceite', 'esencia', 'esencias', 'mascarilla', 'mascarillas', 'contorno-de-ojos', 'hidratante', 'dispositivos', 'mascarilla-de-velo', 'jabon', 'balsamos-en-barra', 'mist'],
      excludeTerms: ['protector solar', 'bloqueador solar', 'contorno de ojos', 'eye cream', 'limpiador', 'cleanser', 'mist'],
      essential: true, limit: 2
    },
    {
      id: 'eye', group: 'treat', title: 'Contorno de ojos',
      description: 'Cuida la zona delicada del contorno.',
      tags: ['contorno de ojos'], requireTags: ['contorno de ojos'],
      collectionHandles: ['contorno-de-ojos'],
      excludeCollectionHandles: ['contorno-de-ojos-con-retinol'],
      excludeTerms: ['parche para los ojos', 'eye patch', 'hidratante'],
      essential: false, limit: 1
    },
    {
      id: 'moisturizer', group: 'protect', title: 'Hidratante',
      description: 'Sella toda la rutina y mantiene la piel nutrida y protegida.',
      tags: ['hidratante', 'crema facial'], requireTags: ['hidratante'],
      collectionHandles: ['hidratante'],
      excludeCollectionHandles: ['mist', 'contorno-de-ojos', 'contorno-de-ojos-con-retinol'],
      excludeTerms: ['contorno de ojos', 'eye cream', 'mist'],
      essential: true, limit: 1
    },
    {
      id: 'sunscreen', group: 'protect', title: 'Protector solar',
      description: 'Protege frente a manchas, arrugas y daño solar; es el paso diurno más importante.',
      tags: ['proteccion solar', 'protector solar', 'bloqueador solar'],
      collectionHandles: ['proteccion-solar', 'protector-solar', 'bloqueador-solar'],
      excludeTerms: ['bloqueadorretoque', 'protector solar de retoque', 'sun stick', 'sun cushion'],
      essential: true, limit: 1
    },
    {
      id: 'sun_retouch', group: 'protect', title: 'Protector solar de retoque',
      description: 'Formato práctico para reaplicar la protección durante el día.',
      tags: ['bloqueadorretoque', 'protector solar de retoque'], requireTags: ['bloqueadorretoque'],
      essential: false, limit: 1
    },
    {
      id: 'spot_treatment', group: 'treat', title: 'Tratamiento puntual de brotes',
      description: 'Parches o tratamiento localizado para granitos específicos.',
      tags: ['granitos'], requireTags: ['granitos'],
      essential: false, limit: 1, goal: 'acne'
    },
    {
      id: 'mist', group: 'finish', title: 'Mist',
      description: 'Refresca, hidrata y calma la piel durante el día.',
      tags: ['mist'], collectionHandles: ['mist'], requireCollection: true,
      essential: false, limit: 1
    },
    {
      id: 'multi_balm', group: 'finish', title: 'Multi Balm o bálsamo en barra',
      description: 'Sella la hidratación y permite retoques rápidos durante el día.',
      tags: ['balsamos en barra', 'balsamo en barra', 'multi balm'],
      collectionHandles: ['balsamos-en-barra', 'multi-balm-o-balsamos-en-barra'], requireCollection: true,
      excludeTerms: ['bloqueadorretoque', 'protector solar', 'sun stick'],
      essential: false, limit: 1
    }
  ];

  const ROUTINE_GROUPS = [
    { id: 'cleanse', eyebrow: 'Paso inicial', title: 'Limpieza' },
    { id: 'prepare', eyebrow: 'Prepara la piel', title: 'Preparación e hidratación' },
    { id: 'treat', eyebrow: 'Objetivo principal', title: 'Tratamiento' },
    { id: 'protect', eyebrow: 'Cuidado diario', title: 'Hidratación y protección' },
    { id: 'finish', eyebrow: 'Para completar', title: 'Retoques y complementos' }
  ];

  const normalise = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/½/g, 'o')
    .trim()
    .toLowerCase();

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  function init(root) {
    if (!root || root.dataset.miiqInitialised === 'true') return;
    root.dataset.miiqInitialised = 'true';

    const stage = root.querySelector('[data-miiq-stage]');
    const back = root.querySelector('[data-miiq-back]');
    const live = root.querySelector('[data-miiq-live]');
    const progress = root.querySelector('[data-miiq-progress]');
    const progressTrack = root.querySelector('[data-miiq-progress-track]');
    const progressLabel = root.querySelector('[data-miiq-progress-label]');
    const progressPercent = root.querySelector('[data-miiq-progress-percent]');
    const productTemplate = root.querySelector('[data-miiq-product-template]');
    const rootUrl = `${root.dataset.rootUrl || '/'}${String(root.dataset.rootUrl || '/').endsWith('/') ? '' : '/'}`;
    const maxPages = Math.max(1, Number(root.dataset.maxPages || 4));
    const locale = root.dataset.locale || 'es-EC';
    const currency = root.dataset.currency || 'USD';
    const responseEndpoint = String(root.dataset.responseEndpoint || '').trim();
    const state = {
      current: 'welcome', history: ['welcome'], name: '', customerEmail: '', answers: {}, selected: new Map(),
      selectionMode: 'complete', catalogPromise: null, retinoidProductIds: new Set(),
      collectionProductIds: new Map(), collectionPromises: new Map(), buildToken: 0,
      submissionId: '', submissionPending: false, submitted: false
    };

    function announce(text) {
      live.textContent = '';
      window.setTimeout(() => { live.textContent = text; }, 20);
    }

    function updateProgress(screen) {
      const value = PROGRESS[screen] || 0;
      progress.style.transform = `scaleX(${value / 100})`;
      progressTrack.setAttribute('aria-valuenow', String(value));
      progressLabel.textContent = SCREEN_LABELS[screen] || '';
      progressPercent.textContent = `${value}%`;
      back.hidden = state.history.length <= 1;
    }

    function navigate(next, push = true) {
      if (!next) return;
      state.current = next;
      if (push && state.history[state.history.length - 1] !== next) state.history.push(next);
      renderScreen(next);
      updateProgress(next);
      announce(SCREEN_LABELS[next] || 'Siguiente paso');
      const targetTop = root.getBoundingClientRect().top + window.scrollY - 24;
      window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
    }

    function goBack() {
      if (state.history.length <= 1) return;
      state.history.pop();
      navigate(state.history[state.history.length - 1], false);
    }

    function renderWelcome() {
      return `<section class="miiq__screen"><div class="miiq__question miiq__question--welcome">
        <p class="miiq__eyebrow">Miinsecrets · Korean skincare</p>
        <h1>Descubre una rutina pensada para tu piel</h1>
        <p class="miiq__lead">En pocos minutos analizaremos tu tipo de piel, sensibilidad y objetivo principal para ordenar productos compatibles de nuestro catálogo.</p>
        <div class="miiq__note"><span aria-hidden="true">🩺</span><p><strong>Orientación cosmética, no diagnóstico.</strong> Si tienes una condición crónica, alergia o acné severo, consulta con un profesional.</p></div>
        <button class="miiq__primary" type="button" data-start>Comenzar mi diagnóstico →</button>
        <p class="miiq__microcopy">Gratis · Sin crear una cuenta · Productos disponibles en tienda</p>
      </div></section>`;
    }

    function renderName() {
      return `<section class="miiq__screen"><div class="miiq__question">
        <p class="miiq__eyebrow">Primero, nos presentamos</p><h2>¿Cuál es tu nombre?</h2>
        <p class="miiq__lead">Así podemos personalizar tu resultado.</p>
        <form class="miiq__name-form" data-name-form novalidate>
          <label class="visually-hidden" for="MiiqName-${escapeHtml(root.dataset.sectionId)}">Nombre</label>
          <input id="MiiqName-${escapeHtml(root.dataset.sectionId)}" class="miiq__input" type="text" minlength="3" maxlength="128" autocomplete="given-name" placeholder="Escribe tu nombre aquí" value="${escapeHtml(state.name)}" data-name>
          <p class="miiq__field-error" data-name-error hidden>Escribe al menos 3 caracteres.</p>
          <button class="miiq__primary" type="submit">Continuar →</button>
        </form>
      </div></section>`;
    }

    function renderAllergy() {
      return `<section class="miiq__screen"><div class="miiq__question">
        <div class="miiq__note miiq__note--warning miiq__note--large"><span class="miiq__note-icon" aria-hidden="true">🧪</span><div>
          <p class="miiq__eyebrow">Seguridad e ingredientes</p><h2>Atención con tus alergias</h2>
          <p>Priorizaremos productos suaves, pero ningún quiz puede confirmar que un cosmético sea seguro para una alergia concreta. Revisa siempre la lista INCI y evita los ingredientes que ya sabes que te causan reacción.</p>
        </div></div>
        <button class="miiq__primary" type="button" data-allergy-results>Continuar →</button>
      </div></section>`;
    }

    function renderEmail() {
      return `<section class="miiq__screen"><div class="miiq__question">
        <p class="miiq__eyebrow">Guarda tus recomendaciones</p>
        <h2>¿Quieres recibir una copia de tu rutina?</h2>
        <p class="miiq__lead">Escribe tu correo y te enviaremos automáticamente tus respuestas, productos recomendados e indicaciones para que puedas revisarlos cuando quieras.</p>
        <form class="miiq__name-form" data-email-form novalidate>
          <label class="visually-hidden" for="MiiqEmail-${escapeHtml(root.dataset.sectionId)}">Correo electrónico opcional</label>
          <input id="MiiqEmail-${escapeHtml(root.dataset.sectionId)}" class="miiq__input" type="email" inputmode="email" autocomplete="email" placeholder="nombre@correo.com" value="${escapeHtml(state.customerEmail)}" data-email>
          <p class="miiq__field-error" data-email-error hidden>Revisa que el correo esté escrito correctamente.</p>
          <button class="miiq__primary" type="submit">Enviar mi rutina y ver resultados →</button>
        </form>
        <button class="miiq__text-button" type="button" data-skip-email>Continuar sin correo</button>
        <p class="miiq__microcopy">Solo usaremos este correo para enviarte esta copia. No te suscribe a promociones.</p>
      </div></section>`;
    }

    function renderQuestion(screen, definition) {
      const currentValue = state.answers[screen];
      const options = definition.options.map((option) => {
        const [value, label, detail, image, alt, badge] = option;
        if (definition.picture) {
          return `<button class="miiq__picture-option${currentValue === value ? ' is-selected' : ''}" type="button" data-answer="${escapeHtml(value)}">
            <img src="${escapeHtml(image)}" alt="${escapeHtml(alt)}" loading="lazy" width="480" height="480">
            <span>${escapeHtml(label)}${detail ? `<small>${escapeHtml(detail)}</small>` : ''}</span>
          </button>`;
        }
        return `<button class="miiq__option${badge ? ' miiq__option--recommended' : ''}${currentValue === value ? ' is-selected' : ''}" type="button" data-answer="${escapeHtml(value)}">
          <strong>${escapeHtml(label)}</strong>${detail ? `<small>${escapeHtml(detail)}</small>` : ''}${badge ? `<span class="miiq__badge">${escapeHtml(badge)}</span>` : ''}
        </button>`;
      }).join('');
      const pictureClasses = `miiq__picture-options${definition.four ? ' miiq__picture-options--four' : ''}`;
      return `<section class="miiq__screen"><div class="miiq__question${definition.picture ? ' miiq__question--wide' : ''}">
        <p class="miiq__eyebrow">${escapeHtml(definition.eyebrow)}</p><h2>${escapeHtml(definition.title)}</h2>
        ${definition.lead ? `<p class="miiq__lead">${escapeHtml(definition.lead)}</p>` : ''}
        <div class="${definition.picture ? pictureClasses : 'miiq__options'}" role="group" aria-label="${escapeHtml(definition.title)}">${options}</div>
      </div></section>`;
    }

    function renderResultsShell() {
      const heading = state.name ? `${escapeHtml(state.name)}, tu rutina está lista ✨` : 'Tu rutina está lista ✨';
      return `<section class="miiq__screen miiq__screen--results">
        <div class="miiq__results" data-results>
          <div class="miiq__results-hero"><p class="miiq__eyebrow">Tu diagnóstico cosmético</p><h2>${heading}</h2>
            <p>Hemos seleccionado productos ideales para ti, basados en tus respuestas y en las necesidades de tu piel.</p>
            <div class="miiq__profile" data-profile></div>
          </div>
          <section class="miiq__result-guidance" aria-label="Cómo comenzar tu rutina">
            <p>Hemos organizado una rutina completa con opciones para cada paso clave del skincare coreano.</p>
            <p><strong>✨ Nuestra recomendación principal es seguir la rutina completa</strong> para que cada producto cumpla una función y los pasos trabajen juntos.</p>
            <h3>Elige cómo quieres comenzar:</h3>
            <div class="miiq__routine-levels">
              <button class="miiq__level-card is-active" type="button" data-select-complete><span class="miiq__level-kicker">Recomendada</span><strong>✨ Rutina completa</strong><small>Selecciona un producto compatible de cada paso para aprovechar la rutina completa.</small><span>Elegir rutina completa →</span></button>
              <button class="miiq__level-card" type="button" data-select-essential><span class="miiq__level-kicker">Menor presupuesto</span><strong>⭐ 4 productos esenciales</strong><small>Limpiador a base de agua, sérum, hidratante y protector solar.</small><span>Comenzar con esenciales →</span></button>
            </div>
            <p><strong>💡 No es necesario que compres todo de una vez.</strong> Si prefieres empezar poco a poco, prioriza los esenciales e incorpora los demás según tu presupuesto y las necesidades de tu piel. Puedes marcar o desmarcar cualquier producto antes de añadir la rutina al carrito.</p>
          </section>
          <div class="miiq__notices" data-notices></div>
          <section class="miiq__result-group"><div class="miiq__group-heading"><div><p class="miiq__eyebrow">Rutina completa recomendada</p><h3>Tus productos recomendados</h3><p>Los productos marcados forman tu selección actual. Puedes personalizarla antes de comprar.</p></div>
            <div class="miiq__legend"><span class="miiq__dot miiq__dot--essential"></span> Esencial <span class="miiq__dot"></span> Recomendado</div></div>
            <div class="miiq__routine" data-basic-results><div class="miiq__loading"><span></span><p>Analizando el catálogo y preparando tu rutina…</p></div></div>
          </section>
          <section class="miiq__result-group" data-advanced-section hidden><div class="miiq__group-heading"><div><p class="miiq__eyebrow">Uso nocturno</p><h3>Tratamientos avanzados: retinol y retinal</h3><p>Opcionales. Empieza 1–2 noches por semana, aumenta gradualmente según tolerancia y usa protector solar cada mañana.</p></div></div>
            <div class="miiq__note miiq__note--warning"><span aria-hidden="true">⚠️</span><p>Activos más potentes: empieza 1–2 noches por semana y aumenta gradualmente. No combines varios retinoides. Se añaden individualmente y no forman parte de “Añadir mi rutina”.</p></div>
            <div class="miiq__products miiq__products--compact" data-advanced-results></div>
          </section>
          <section class="miiq__result-group" data-extras-section hidden><div class="miiq__group-heading"><div><p class="miiq__eyebrow">Descubre más</p><h3>Complementa tu rutina</h3><p>Opciones adicionales para potenciar o facilitar tu experiencia.</p></div></div>
            <div class="miiq__extra-groups" data-extra-results></div>
          </section>
          <div class="miiq__empty" data-empty hidden><h3>No pudimos cargar el catálogo en este momento</h3><p>Tus respuestas siguen aquí. Puedes explorar el catálogo o escribirnos para recibir ayuda.</p></div>
          <section class="miiq__help"><h3>¡Gracias por completar el test!</h3><p>Los productos recomendados fueron seleccionados para atender las necesidades específicas de tu piel. Si tienes dudas o necesitas ayuda para decidir, envíanos una captura de tus resultados por WhatsApp. Estamos aquí para ayudarte.</p>
            <div class="miiq__help-actions"><a class="miiq__secondary" href="${escapeHtml(root.dataset.whatsappUrl)}" target="_blank" rel="noopener">WhatsApp</a>
              <a class="miiq__secondary" href="${escapeHtml(root.dataset.catalogUrl)}">Ver catálogo completo</a><a class="miiq__secondary" href="${escapeHtml(root.dataset.searchUrl)}">Buscar un producto</a></div>
            <button class="miiq__text-button" type="button" data-restart>↻ Retomar el quiz</button>
          </section>
        </div>
        <div class="miiq__cart-bar" data-cart-bar hidden><div><strong data-selected-count>0 productos seleccionados</strong><span data-selected-total></span></div>
          <button class="miiq__primary miiq__primary--cart" type="button" data-add-selected>Añadir mi rutina al carrito</button></div>
      </section>`;
    }

    function bindScreen(screen) {
      const start = stage.querySelector('[data-start]');
      if (start) start.addEventListener('click', () => navigate('name'));

      const nameForm = stage.querySelector('[data-name-form]');
      if (nameForm) nameForm.addEventListener('submit', (event) => {
        event.preventDefault();
        const input = nameForm.querySelector('[data-name]');
        const error = nameForm.querySelector('[data-name-error]');
        const value = input.value.trim();
        if (value.length < 3) { error.hidden = false; input.focus(); return; }
        state.name = value;
        navigate('age');
      });

      stage.querySelectorAll('[data-answer]').forEach((button) => button.addEventListener('click', () => {
        const value = button.dataset.answer;
        state.answers[screen] = value;
        stage.querySelectorAll('[data-answer]').forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        const next = ROUTES[screen] ? ROUTES[screen](value, state.answers) : null;
        window.setTimeout(() => navigate(next), 170);
      }));

      const allergyResults = stage.querySelector('[data-allergy-results]');
      if (allergyResults) allergyResults.addEventListener('click', () => navigate('email'));

      const emailForm = stage.querySelector('[data-email-form]');
      if (emailForm) emailForm.addEventListener('submit', (event) => {
        event.preventDefault();
        const input = emailForm.querySelector('[data-email]');
        const error = emailForm.querySelector('[data-email-error]');
        const value = input.value.trim().toLowerCase();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) { error.hidden = false; input.focus(); return; }
        state.customerEmail = value;
        navigate('results');
      });

      const skipEmail = stage.querySelector('[data-skip-email]');
      if (skipEmail) skipEmail.addEventListener('click', () => {
        state.customerEmail = '';
        navigate('results');
      });

      const completePreset = stage.querySelector('[data-select-complete]');
      if (completePreset) completePreset.addEventListener('click', () => applySelectionPreset('complete'));
      const essentialPreset = stage.querySelector('[data-select-essential]');
      if (essentialPreset) essentialPreset.addEventListener('click', () => applySelectionPreset('essential'));

      const restart = stage.querySelector('[data-restart]');
      if (restart) restart.addEventListener('click', () => {
        state.current = 'welcome'; state.history = ['welcome']; state.name = ''; state.customerEmail = ''; state.answers = {}; state.selected.clear(); state.selectionMode = 'complete'; state.buildToken += 1;
        state.submissionId = ''; state.submissionPending = false; state.submitted = false;
        navigate('welcome', false);
      });
    }

    function renderScreen(screen) {
      state.buildToken += 1;
      if (screen === 'welcome') stage.innerHTML = renderWelcome();
      else if (screen === 'name') stage.innerHTML = renderName();
      else if (screen === 'allergy') stage.innerHTML = renderAllergy();
      else if (screen === 'email') stage.innerHTML = renderEmail();
      else if (screen === 'results') stage.innerHTML = renderResultsShell();
      else stage.innerHTML = renderQuestion(screen, SCREENS[screen]);
      bindScreen(screen);
      if (screen === 'results') buildResults(state.buildToken);
      const focusTarget = stage.querySelector('h1, h2');
      if (focusTarget) { focusTarget.setAttribute('tabindex', '-1'); focusTarget.focus({ preventScroll: true }); }
    }

    function addVote(profile, tag, weight) {
      const key = normalise(tag);
      profile.votes.set(key, (profile.votes.get(key) || 0) + weight);
    }

    function exclude(profile, ...tags) { tags.forEach((tag) => profile.excluded.add(normalise(tag))); }
    function boostCollection(profile, handle, weight) { if (handle) profile.collections.set(normalise(handle), weight); }

    function deriveProfile() {
      const a = state.answers;
      const profile = { answers: a, votes: new Map(), excluded: new Set(), collections: new Map(), flags: {}, labels: [] };

      // Restricciones globales para la rutina facial: nunca recomendar formatos mini,
      // sets, kits ni productos corporales/capilares dentro de los 14 pasos.
      exclude(profile, 'set', 'sets', 'mini', 'minis', 'kit', 'kits', 'cuerpo', 'corporal', 'cabello');

      if (a.age) profile.labels.push(LABELS.age[a.age]);
      if (a.age === 'under20') {
        profile.flags.noRetinoids = true;
        exclude(profile, 'retinol', 'retinol 0.1%', 'retinal', 'retinaldehyde', 'retinoide', 'retinoid');
      }

      if (a.pregnancy) profile.labels.push(LABELS.pregnancy[a.pregnancy]);
      if (a.pregnancy === 'pregnant' || a.pregnancy === 'lactating') {
        profile.flags.noRetinoids = true;
        profile.flags.pregnancy = true;
        addVote(profile, 'apto embarazo', 8);
        exclude(profile, 'retinol', 'retinol 0.1%', 'retinal', 'retinaldehyde', 'retinoide', 'retinoid', 'evitar embarazo');
        if (a.pregnancy === 'lactating') exclude(profile, 'no embarazadas/lactancia', 'no apto embarazo si contiene vitamina c');
      }

      if (a.skin) profile.labels.push(LABELS.skin[a.skin]);

// PRIORIDAD 1: TIPO DE PIEL
// El tipo de piel debe pesar más que cualquier necesidad secundaria.
if (a.skin === 'normal') {
  addVote(profile, 'Piel Normal', 100);
}

if (a.skin === 'oily') {
  addVote(profile, 'Piel Grasa', 100);
  boostCollection(profile, 'piel-grasa', 10);
}

if (a.skin === 'dry') {
  addVote(profile, 'Piel Seca', 100);
  exclude(profile, 'acabado mate');
}

if (a.skin === 'combination') {
  addVote(profile, 'Piel Mixta', 100);
}

if (a.skin === 'sensitive') {
  addVote(profile, 'Piel Sensible', 100);
  profile.flags.sensitive = true;
  profile.flags.noRetinoids = true;
}

      if (a.climate) profile.labels.push(LABELS.climate[a.climate]);
      if (a.climate === 'humid_hot') { addVote(profile, 'acabado mate', 3); exclude(profile, 'sets'); }
      if (a.climate === 'dry_hot' || a.climate === 'cold_dry') exclude(profile, 'acabado mate');
      if (a.climate === 'temperate' || a.climate === 'variable') exclude(profile, 'sets');

      if (a.sensitivity === 'rosacea') { addVote(profile, 'quizsensibilidad', 9); addVote(profile, 'quizrosacea', 10); profile.flags.sensitive = true; }
      if (['weather_reactive', 'active_reaction', 'damaged_barrier'].includes(a.sensitivity)) {
        addVote(profile, 'quizsensibilidad', 9); addVote(profile, 'quizbarrera', 10); profile.flags.sensitive = true;
      }
      if (['active_reaction', 'damaged_barrier'].includes(a.sensitivity)) profile.flags.reactive = true;
      if (a.sensitivity === 'allergy') { addVote(profile, 'quizsensibilidad', 10); profile.flags.sensitive = true; profile.flags.allergy = true; }
      if (profile.flags.sensitive) profile.flags.noRetinoids = true;

      if (a.barrier === 'recover') { addVote(profile, 'quizbarrera', 30); profile.flags.barrierOnly = true; profile.flags.noRetinoids = true; }

      if (a.goal) profile.labels.push(LABELS.goal[a.goal]);
      if (a.goal === 'acne') {
        addVote(profile, 'acne', 4);
        addVote(profile, 'piel con acne', 4);
      }
      if (a.goal === 'spots') addVote(profile, 'manchas', 5);
      if (a.goal === 'antiage') {
        addVote(profile, 'quizarrugasyfirmeza', 12);
        boostCollection(profile, root.dataset.retinolSerumCollection, 8);
        boostCollection(profile, root.dataset.retinolEyeCollection, 8);
      }
      if (a.goal === 'hydration') { addVote(profile, 'quizdeshidratada', 14); addVote(profile, 'hidratante', 3); }
      if (a.goal === 'pores') {
        addVote(profile, 'poros', 5);
        boostCollection(profile, root.dataset.retinolSerumCollection, 4);
      }

      if (a.antiage) { addVote(profile, 'quizarrugasyfirmeza', a.antiage === 'none' ? 10 : 14); addVote(profile, 'quizmanchasarrugas', 10); addVote(profile, 'quizsignosdelaedad', 10); }

      const spotTags = { post_acne: 'Quizmanchaspostacne', melasma: 'quizmelasma', solar: 'quizmanchassolares', redness: 'quizmanchasensibles', age_spots: 'quizmanchasantiedad' };
      if (a.spots) addVote(profile, spotTags[a.spots], 18);

      const acneTags = { comedonal: 'Quizacnecomedogenico', inflammatory: 'quizacneinflamatorio', hormonal: 'quizacnehormonal', cystic: 'quizacnequistico' };
      const acneCollections = { comedonal: 'quizacnecomedogenico', inflammatory: 'quizacneinflamatorio', hormonal: 'quizacnehormonal', cystic: 'quizacnequistico' };
      if (a.acne) {
        addVote(profile, acneTags[a.acne], 18);
        boostCollection(profile, acneCollections[a.acne], 14);
        if (a.acne === 'hormonal' || a.acne === 'cystic') boostCollection(profile, root.dataset.retinolSerumCollection, 8);
      }

      const poreTags = { oil: 'quizexcesodegrasa', clogged: 'quizporosobstruidos', elasticity: 'quizporoselasticidad', dehydration: 'quizporosdeshidratacion' };
      const poreCollections = { clogged: 'quizporosobstruidos', elasticity: 'quizporoselasticidad', dehydration: 'quizporosdeshidratacion' };
      if (a.pores) { addVote(profile, poreTags[a.pores], 18); if (poreCollections[a.pores]) boostCollection(profile, poreCollections[a.pores], 14); }

      return profile;
    }

    async function getJson(url) {
      const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json();
    }

    function normaliseProduct(raw) {
      if (!raw) return null;
      const tags = Array.isArray(raw.tags) ? raw.tags : String(raw.tags || '').split(',').map((tag) => tag.trim()).filter(Boolean);
      const images = (raw.images || []).map((image) => typeof image === 'string' ? image : (image.src || image.url || '')).filter(Boolean);
      const variants = (raw.variants || []).map((variant) => ({
        id: Number(variant.id),
        title: variant.title || 'Predeterminada',
        available: variant.available !== false,
        price: variant.price,
        compareAtPrice: variant.compare_at_price || variant.compareAtPrice || null
      }));
      return {
        id: Number(raw.id), handle: raw.handle || '', title: raw.title || '', vendor: raw.vendor || '',
        tags, tagSet: new Set(tags.map(normalise)), images, variants,
        featuredImage: raw.featured_image ? (typeof raw.featured_image === 'string' ? raw.featured_image : raw.featured_image.src) : images[0] || ''
      };
    }

    function mergeProducts(target, products) {
      products.forEach((raw) => {
        const product = raw.tagSet ? raw : normaliseProduct(raw);
        if (product && product.id) target.set(product.id, product);
      });
    }

    function rememberCollection(handle, products) {
      if (!handle) return;
      state.collectionProductIds.set(normalise(handle), new Set(products.map((product) => Number(product.id))));
    }

    async function fetchCollection(handle, limit = 250) {
      if (!handle) return [];
      const key = `${normalise(handle)}:${limit}`;
      if (state.collectionPromises.has(key)) return state.collectionPromises.get(key);
      const request = (async () => {
        try {
          const data = await getJson(`${rootUrl}collections/${encodeURIComponent(handle)}/products.json?limit=${limit}`);
          return data.products || [];
        } catch (error) { return []; }
      })();
      state.collectionPromises.set(key, request);
      return request;
    }

    async function fetchProduct(handle) {
      if (!handle) return null;
      try { return normaliseProduct(await getJson(`${rootUrl}products/${encodeURIComponent(handle)}.js`)); }
      catch (error) { return null; }
    }

    async function fetchCatalog() {
      if (state.catalogPromise) return state.catalogPromise;
      state.catalogPromise = (async () => {
        const products = new Map();
        for (let page = 1; page <= maxPages; page += 1) {
          const data = await getJson(`${rootUrl}collections/all/products.json?limit=250&page=${page}`);
          const batch = data.products || [];
          mergeProducts(products, batch);
          if (batch.length < 250) break;
        }
        const retinoidHandles = ['retinol', 'retinal', 'retinoides', root.dataset.retinolSerumCollection, root.dataset.retinolEyeCollection].filter(Boolean);
        const categoryHandles = CATEGORIES.flatMap((category) => [
          ...(category.collectionHandles || []),
          ...(category.excludeCollectionHandles || [])
        ]);
        const collectionHandles = [...new Set([...retinoidHandles, ...categoryHandles].filter(Boolean))];
        const batches = await Promise.all(collectionHandles.map(async (handle) => ({ handle, products: await fetchCollection(handle) })));
        batches.forEach(({ handle, products: batch }) => {
          rememberCollection(handle, batch);
          if (retinoidHandles.map(normalise).includes(normalise(handle))) {
            batch.forEach((product) => state.retinoidProductIds.add(Number(product.id)));
          }
          mergeProducts(products, batch);
        });
        return [...products.values()];
      })().catch((error) => { state.catalogPromise = null; throw error; });
      return state.catalogPromise;
    }

    function hasAnyTag(product, tags) { return tags.some((tag) => product.tagSet.has(normalise(tag))); }
    function belongsToCollection(product, handles) {
      return (handles || []).some((handle) => state.collectionProductIds.get(normalise(handle))?.has(Number(product.id)));
    }
    function matchesCategory(product, category) {
      const text = productSearchText(product);
      if ((category.excludeTerms || []).some((term) => text.includes(normalise(term)))) return false;
      if (belongsToCollection(product, category.excludeCollectionHandles)) return false;
      if ((category.requireTags || []).length && !hasAnyTag(product, category.requireTags)) return false;
      const collectionMatch = belongsToCollection(product, category.collectionHandles);
      if (category.requireCollection && !collectionMatch) return false;
      if (collectionMatch || hasAnyTag(product, category.tags || [])) return true;
      return (category.titleTerms || []).some((term) => text.includes(normalise(term)));
    }
    function isAvailable(product) { return product.variants.some((variant) => variant.available); }
    function productSearchText(product) { return normalise(`${product.title} ${product.tags.join(' ')}`); }
    function isRetinoid(product) { return state.retinoidProductIds.has(product.id) || /\b(retinol|retinal|retinaldehyde|retinoide|retinoid|reti-a)\b/.test(productSearchText(product)); }
    function isStrongActive(product) { return /\b(aha|bha|peeling|glicolico|glycolic|salicilico|salicylic|exfoliante fuerte|retinol|retinal|retinaldehyde|benzoyl peroxide|peroxido de benzoilo|reedle|spicule)\b/.test(productSearchText(product)); }
    function isReactiveActive(product) { return /\b(aha|bha|pha|peeling|glicolico|glycolic|salicilico|salicylic|mandelico|mandelic|lactico|lactic|ascorbic acid|acido ascorbico|vitamina c|vitamin c|benzoyl peroxide|peroxido de benzoilo|reedle|spicule|retinol|retinal|retinaldehyde)\b/.test(productSearchText(product)); }
    function isMiniOrSet(product) {
      const tags = product.tagSet;
      return ['mini', 'minis', 'set', 'sets', 'kit', 'kits'].some((tag) => tags.has(tag)) || /\b(mini|set|kit)\b/.test(normalise(product.title));
    }
    function isBodyOrHair(product) {
      const tags = product.tagSet;
      return ['cuerpo', 'corporal', 'cabello', 'body', 'hair'].some((tag) => tags.has(tag));
    }

    function isExcluded(product, profile, basic = true, facial = true) {
      if (!isAvailable(product)) return true;
      if (isMiniOrSet(product)) return true;
      if (facial && isBodyOrHair(product)) return true;
      if ([...profile.excluded].some((tag) => product.tagSet.has(tag))) return true;
      if ((basic || profile.flags.noRetinoids) && isRetinoid(product)) return true;
      if (profile.flags.pregnancy && isStrongActive(product)) return true;
      if ((profile.flags.sensitive || profile.flags.barrierOnly || profile.flags.allergy) && isStrongActive(product)) return true;
      if ((profile.flags.reactive || profile.flags.barrierOnly) && isReactiveActive(product)) return true;
      return false;
    }

    function matchesSafetyProfile(product, profile) {
      if (profile.flags.barrierOnly) return hasAnyTag(product, ['quizbarrera', 'quizsensibilidad', 'piel sensible']);
      if (profile.flags.allergy) return hasAnyTag(product, ['quizsensibilidad', 'quizbarrera', 'piel sensible']);
      if (profile.flags.sensitive) return hasAnyTag(product, ['quizsensibilidad', 'quizrosacea', 'quizbarrera', 'piel sensible']);
      return true;
    }

    function scoreProduct(product, profile, collectionScores) {
      let score = collectionScores.get(product.id) || 0;
      profile.votes.forEach((weight, tag) => { if (product.tagSet.has(tag)) score += weight; });
      return score;
    }

    async function collectionScores(profile) {
      const scores = new Map();
      const entries = [...profile.collections.entries()];
      await Promise.all(entries.map(async ([handle, weight]) => {
        const products = await fetchCollection(handle);
        products.forEach((product) => scores.set(Number(product.id), (scores.get(Number(product.id)) || 0) + weight));
      }));
      return scores;
    }

    function eligibleVariants(product) { return product.variants.filter((variant) => variant.available); }

    function toCents(value) {
      if (value === null || value === undefined || value === '') return null;
      if (typeof value === 'number') return Number.isInteger(value) ? value : Math.round(value * 100);
      const string = String(value).replace(/[^0-9.-]/g, '');
      if (!string) return null;
      return string.includes('.') ? Math.round(Number(string) * 100) : (Number(string) > 999 ? Number(string) : Number(string) * 100);
    }

    function formatMoney(value) {
      const cents = toCents(value);
      if (cents === null) return '';
      try { return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100); }
      catch (error) { return `$${(cents / 100).toFixed(2)}`; }
    }

    function priceMarkup(variant) {
      const price = formatMoney(variant.price);
      const compare = toCents(variant.compareAtPrice);
      const current = toCents(variant.price);
      return compare && current && compare > current ? `<span>${escapeHtml(price)}</span><s>${escapeHtml(formatMoney(variant.compareAtPrice))}</s>` : `<span>${escapeHtml(price)}</span>`;
    }

    function reasonFor(product, profile, fallback) {
      const matches = [];
      profile.votes.forEach((weight, tag) => { if (weight >= 6 && product.tagSet.has(tag)) matches.push(tag); });
      if (matches.length && profile.answers.skin) return `${fallback} · ${LABELS.skin[profile.answers.skin]}`;
      return fallback;
    }

    function renderProductCard(product, options) {
      const card = productTemplate.content.firstElementChild.cloneNode(true);
      const variants = eligibleVariants(product);
      if (!variants.length) return null;
      const check = card.querySelector('[data-miiq-product-check]');
      const selectLabel = check.closest('.miiq__select-product');
      const selectText = card.querySelector('[data-miiq-select-text]');
      const selectable = options.selectable !== false;
      const image = card.querySelector('[data-miiq-product-image]');
      const imageLink = card.querySelector('[data-miiq-product-link]');
      const titleLink = card.querySelector('[data-miiq-product-title]');
      const price = card.querySelector('[data-miiq-product-price]');
      const reason = card.querySelector('[data-miiq-product-reason]');
      const stepDescription = card.querySelector('[data-miiq-step-description]');
      const variantWrap = card.querySelector('[data-miiq-variant-wrap]');
      const variantSelect = card.querySelector('[data-miiq-variant]');
      const addOne = card.querySelector('[data-miiq-add-one]');
      const status = card.querySelector('[data-miiq-card-status]');
      const productUrl = `${rootUrl}products/${product.handle}`;
      let chosen = variants[0];

      image.src = product.featuredImage || product.images[0] || '';
      image.alt = product.title;
      imageLink.href = productUrl;
      titleLink.href = productUrl;
      titleLink.textContent = product.title;
      reason.textContent = options.reason || 'Recomendado para ti';
      if (stepDescription) {
        stepDescription.textContent = options.stepDescription || '';
        stepDescription.hidden = !options.stepDescription;
      }
      price.innerHTML = priceMarkup(chosen);
      card.dataset.productId = String(product.id);
      card.dataset.variantId = String(chosen.id);
      card.dataset.routineComplete = options.complete ? 'true' : 'false';
      card.dataset.routineEssential = options.essential ? 'true' : 'false';
      card.dataset.routineSelectable = selectable ? 'true' : 'false';
      card.dataset.routineGroup = options.group || '';
      card.dataset.recommendationCategory = options.category || options.reason || options.group || 'Producto recomendado';
      card.dataset.productTitle = product.title;
      card.dataset.productUrl = productUrl;
      card.dataset.variantTitle = chosen.title;
      card.dataset.priceFormatted = formatMoney(chosen.price);
      if (!selectable) selectLabel.hidden = true;
      if (options.showEssentialBadge ?? options.essential) card.classList.add('miiq__product-card--essential');
      if (options.alternative) card.classList.add('miiq__product-card--alternative');
      if (options.choiceSet) {
        card.classList.add('miiq__product-card--choice');
        selectText.hidden = false;
      }

      const selectionItem = () => ({
        id: Number(card.dataset.variantId),
        productId: product.id,
        group: options.group,
        priceCents: toCents(chosen.price) || 0
      });

      if (variants.length > 1) {
        variantWrap.hidden = false;
        variants.forEach((variant) => {
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = `${variant.title} · ${formatMoney(variant.price)}`;
          variantSelect.appendChild(option);
        });
        variantSelect.addEventListener('change', () => {
          chosen = variants.find((variant) => String(variant.id) === variantSelect.value) || variants[0];
          card.dataset.variantId = String(chosen.id);
          card.dataset.variantTitle = chosen.title;
          card.dataset.priceFormatted = formatMoney(chosen.price);
          price.innerHTML = priceMarkup(chosen);
          if (selectable && check.checked) state.selected.set(`${options.group}:${product.id}`, selectionItem());
        });
      }

      check.checked = selectable && Boolean(options.selected);
      card.classList.toggle('is-selected', check.checked);
      if (options.choiceSet) selectText.textContent = check.checked ? 'Opción elegida' : 'Elegir esta opción';
      if (selectable && check.checked) state.selected.set(`${options.group}:${product.id}`, selectionItem());

      if (selectable) {
        check.addEventListener('change', () => {
          if (check.checked) {
            stage.querySelectorAll('.miiq__product-card').forEach((otherCard) => {
              if (otherCard === card || otherCard.dataset.routineSelectable !== 'true' || otherCard.dataset.routineGroup !== card.dataset.routineGroup) return;
              const otherCheck = otherCard.querySelector('[data-miiq-product-check]');
              if (!otherCheck?.checked) return;
              otherCheck.checked = false;
              otherCard.classList.remove('is-selected');
              const otherText = otherCard.querySelector('[data-miiq-select-text]');
              if (otherText) otherText.textContent = 'Elegir esta opción';
              state.selected.delete(`${options.group}:${otherCard.dataset.productId}`);
            });
          }
          card.classList.toggle('is-selected', check.checked);
          if (options.choiceSet) selectText.textContent = check.checked ? 'Opción elegida' : 'Elegir esta opción';
          const key = `${options.group}:${product.id}`;
          if (check.checked) state.selected.set(key, selectionItem());
          else state.selected.delete(key);
          updateSelectedBar();
        });
      }

      addOne.addEventListener('click', async () => {
        addOne.disabled = true; addOne.textContent = 'Agregando…'; status.textContent = '';
        try {
          await addToCart([{ id: Number(card.dataset.variantId), quantity: 1 }]);
          addOne.textContent = '✓ Agregado'; status.textContent = 'Producto añadido al carrito.';
          window.setTimeout(() => { addOne.disabled = false; addOne.textContent = 'Añadir al carrito'; }, 1800);
        } catch (error) {
          addOne.disabled = false; addOne.textContent = 'Añadir al carrito'; status.textContent = 'No se pudo agregar. Intenta de nuevo.';
        }
      });
      return card;
    }

    function updateSelectedBar() {
      const bar = stage.querySelector('[data-cart-bar]');
      const count = stage.querySelector('[data-selected-count]');
      const totalLabel = stage.querySelector('[data-selected-total]');
      if (!bar || !count) return;
      const total = state.selected.size;
      bar.hidden = total === 0;
      count.textContent = `${total} ${total === 1 ? 'producto seleccionado' : 'productos seleccionados'}`;
      const totalCents = [...state.selected.values()].reduce((sum, item) => sum + (Number(item.priceCents) || 0), 0);
      if (totalLabel) totalLabel.textContent = total ? `Total estimado: ${formatMoney(totalCents)}` : '';
    }

    function applySelectionPreset(mode) {
      state.selectionMode = mode;
      stage.querySelectorAll('.miiq__product-card').forEach((card) => {
        if (card.dataset.routineSelectable !== 'true') return;
        const check = card.querySelector('[data-miiq-product-check]');
        const shouldSelect = mode === 'complete' ? card.dataset.routineComplete === 'true' : card.dataset.routineEssential === 'true';
        if (check && check.checked !== shouldSelect) {
          check.checked = shouldSelect;
          check.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      stage.querySelectorAll('[data-select-complete], [data-select-essential]').forEach((button) => button.classList.remove('is-active'));
      const active = stage.querySelector(mode === 'complete' ? '[data-select-complete]' : '[data-select-essential]');
      if (active) active.classList.add('is-active');
      updateSelectedBar();
      announce(mode === 'complete' ? 'Rutina completa seleccionada.' : 'Cuatro productos esenciales seleccionados.');
    }

    async function addToCart(items) {
      const response = await fetch(`${rootUrl}cart/add.js`, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('No se pudo agregar al carrito');
      const payload = await response.json();
      document.dispatchEvent(new CustomEvent('miinsecrets:cart:updated', { detail: payload }));
      return payload;
    }

    function createNote(type, icon, text) {
      const note = document.createElement('div');
      note.className = `miiq__note${type ? ` miiq__note--${type}` : ''}`;
      const symbol = document.createElement('span'); symbol.setAttribute('aria-hidden', 'true'); symbol.textContent = icon;
      const copy = document.createElement('p'); copy.textContent = text;
      note.append(symbol, copy);
      return note;
    }

    function optionLabel(screen, value) {
      if (!value) return '';
      const definition = SCREENS[screen];
      const option = definition?.options?.find((item) => item[0] === value);
      return option ? String(option[1]).replace(/<[^>]*>/g, '') : String(value);
    }

    function goalDetailLabel() {
      const goal = state.answers.goal;
      if (goal && ['antiage', 'spots', 'acne', 'pores'].includes(goal)) return optionLabel(goal, state.answers[goal]);
      if (state.answers.barrier === 'recover') return 'Recuperar la barrera cutánea primero';
      if (state.answers.sensitivity === 'allergy') return 'Alergias conocidas a ingredientes cosméticos';
      return '';
    }

    function createSubmissionId() {
      const date = new Date();
      const stamp = [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('');
      const random = Math.random().toString(36).slice(2, 10).toUpperCase();
      return `MII-${stamp}-${random}`;
    }

    function collectRecommendedProducts() {
      return [...stage.querySelectorAll('.miiq__product-card')].map((card) => ({
        productId: Number(card.dataset.productId || 0),
        variantId: Number(card.dataset.variantId || 0),
        title: card.dataset.productTitle || card.querySelector('[data-miiq-product-title]')?.textContent?.trim() || '',
        category: card.dataset.recommendationCategory || 'Producto recomendado',
        variantTitle: card.dataset.variantTitle || 'Predeterminada',
        priceFormatted: card.dataset.priceFormatted || '',
        selected: Boolean(card.querySelector('[data-miiq-product-check]')?.checked),
        url: card.dataset.productUrl || ''
      })).filter((product) => product.productId && product.title);
    }

    async function sendQuizResult() {
      if (!responseEndpoint || state.submitted || state.submissionPending) return;
      if (!state.submissionId) state.submissionId = createSubmissionId();
      const totalCents = [...state.selected.values()].reduce((sum, item) => sum + (Number(item.priceCents) || 0), 0);
      const payload = {
        submissionId: state.submissionId,
        name: state.name,
        customerEmail: state.customerEmail,
        answers: {
          age: LABELS.age[state.answers.age] || '',
          pregnancy: LABELS.pregnancy[state.answers.pregnancy] || '',
          skin: LABELS.skin[state.answers.skin] || '',
          climate: LABELS.climate[state.answers.climate] || '',
          sensitivity: optionLabel('sensitivity', state.answers.sensitivity),
          barrier: optionLabel('barrier', state.answers.barrier),
          goal: LABELS.goal[state.answers.goal] || (state.answers.barrier === 'recover' ? 'Recuperar barrera' : 'Recomendaciones suaves'),
          goalDetail: goalDetailLabel()
        },
        products: collectRecommendedProducts(),
        totalFormatted: totalCents ? formatMoney(totalCents) : '',
        pageUrl: window.location.href,
        completedAt: new Date().toISOString()
      };

      state.submissionPending = true;
      try {
        await fetch(responseEndpoint, {
          method: 'POST', mode: 'no-cors', keepalive: true,
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(payload)
        });
        state.submitted = true;
        root.dispatchEvent(new CustomEvent('miinsecrets:quiz:recorded', { bubbles: true, detail: { submissionId: state.submissionId } }));
      } catch (error) {
        window.setTimeout(() => { state.submissionPending = false; sendQuizResult(); }, 2500);
        return;
      }
      state.submissionPending = false;
    }

    function renderProfile(profile) {
      const holder = stage.querySelector('[data-profile]');
      profile.labels.filter(Boolean).forEach((label) => { const chip = document.createElement('span'); chip.className = 'miiq__chip'; chip.textContent = label; holder.appendChild(chip); });
      const notices = stage.querySelector('[data-notices]');
      if (profile.flags.pregnancy) notices.appendChild(createNote('warning', '🛡️', 'Se excluyeron automáticamente retinoides y productos etiquetados como no aptos para embarazo o lactancia. Revisa el INCI y consulta con tu profesional de salud si tienes dudas.'));
      if (profile.flags.allergy) notices.appendChild(createNote('danger', '🧪', 'Una recomendación suave no garantiza ausencia de alérgenos. Comprueba la lista INCI de cada producto antes de comprar.'));
      if (profile.flags.barrierOnly) notices.appendChild(createNote('warning', '💛', 'Tu resultado prioriza productos calmantes y de barrera. Los exfoliantes y tratamientos avanzados se han retirado.'));
      else if (profile.flags.sensitive) notices.appendChild(createNote('warning', '🌿', 'Se priorizaron fórmulas para sensibilidad y se retiraron retinoides y exfoliantes fuertes. Introduce un producto a la vez.'));
      if (state.answers.age === 'under20') notices.appendChild(createNote('warning', '🛡️', 'Los retinoides se excluyeron por tu rango de edad.'));
      if (state.answers.acne === 'cystic') notices.appendChild(createNote('danger', '🩺', 'El acné quístico o doloroso puede dejar cicatrices. La rutina es solo de apoyo cosmético; considera una evaluación dermatológica.'));
    }

    async function buildResults(token) {
      state.selected.clear();
      const profile = deriveProfile();
      renderProfile(profile);
      const basicHolder = stage.querySelector('[data-basic-results]');
      const empty = stage.querySelector('[data-empty]');

      try {
        const [catalog, scores] = await Promise.all([fetchCatalog(), collectionScores(profile)]);
        if (token !== state.buildToken || state.current !== 'results') return;
        basicHolder.innerHTML = '';
        const used = new Set();
        let renderedCategories = 0;
        const groupHolders = new Map();

        ROUTINE_GROUPS.forEach((group) => {
          const groupSection = document.createElement('section');
          groupSection.className = 'miiq__routine-group';
          groupSection.dataset.routineGroup = group.id;
          groupSection.hidden = true;
          groupSection.innerHTML = `<div class="miiq__routine-group-heading"><p class="miiq__eyebrow">${escapeHtml(group.eyebrow)}</p><h4>${escapeHtml(group.title)}</h4></div><div class="miiq__routine-grid"></div>`;
          groupHolders.set(group.id, groupSection);
          basicHolder.appendChild(groupSection);
        });

        CATEGORIES.forEach((category) => {
          if (category.goal && category.goal !== profile.answers.goal) return;
          if (category.strong && (profile.flags.sensitive || profile.flags.barrierOnly || profile.flags.allergy)) return;
          const candidates = catalog
            .filter((product) => !used.has(product.id) && !isExcluded(product, profile, true) && matchesCategory(product, category) && matchesSafetyProfile(product, profile))
            .map((product) => ({ product, score: scoreProduct(product, profile, scores) }))
            .filter((item) => item.score > 0)
            .sort((a, b) => b.score - a.score || a.product.title.localeCompare(b.product.title, 'es'))
            .slice(0, category.limit);
          if (!candidates.length) return;
          renderedCategories += 1;
          const groupSection = groupHolders.get(category.group) || groupHolders.get('treat');
          const grid = groupSection.querySelector('.miiq__routine-grid');
          groupSection.hidden = false;

          // Keep every skincare step in its own visual block. Previously the
          // serum alternatives and the following eye-contour step shared one
          // grid row, which made three different cards look like three serum
          // choices.
          const categoryBlock = document.createElement('section');
          categoryBlock.className = `miiq__category-block${candidates.length > 1 ? ' miiq__category-block--choices' : ''}`;
          categoryBlock.dataset.resultCategory = category.id;
          categoryBlock.innerHTML = `<div class="miiq__category-heading"><span>${category.essential ? 'Esencial' : 'Opcional'}</span><h5>${escapeHtml(category.title)}</h5><p>${escapeHtml(category.description)}</p></div><div class="miiq__category-products${candidates.length > 1 ? ' miiq__category-products--choices' : ''}"></div>`;
          const categoryProducts = categoryBlock.querySelector('.miiq__category-products');
          grid.appendChild(categoryBlock);
          if (candidates.length > 1) {
            const choiceNote = document.createElement('div');
            choiceNote.className = 'miiq__choice-note';
            choiceNote.innerHTML = `<strong>Elige 1 opción de ${escapeHtml(category.title)}</strong><span>Este paso es ${category.essential ? 'esencial, pero solo necesitas uno de estos productos' : 'opcional'}. Puedes abrir cada producto para revisar sus ingredientes y detalles; se abrirá en otra pestaña y conservarás tus resultados.</span>`;
            categoryBlock.insertBefore(choiceNote, categoryProducts);
          }
          candidates.forEach(({ product }, index) => {
            used.add(product.id);
            const isPrimary = index === 0;
            const selected = isPrimary && (state.selectionMode === 'complete' || category.essential);
            const card = renderProductCard(product, {
              group: category.id,
              category: category.title,
              selected,
              complete: isPrimary,
              essential: isPrimary && category.essential,
              showEssentialBadge: category.essential && candidates.length === 1,
              choiceSet: candidates.length > 1,
              alternative: !isPrimary,
              reason: candidates.length > 1 ? `Opción ${index + 1} de ${candidates.length} · ${category.title}` : `Paso recomendado · ${category.title}`,
              stepDescription: candidates.length > 1 ? 'Opción compatible para este paso. Revisa la ficha antes de elegir.' : category.description
            });
            if (card) categoryProducts.appendChild(card);
          });
        });

        if (!renderedCategories) { empty.hidden = false; basicHolder.hidden = true; }
        else { empty.hidden = true; basicHolder.hidden = false; }

        renderAdvanced(catalog, profile, scores, used);
        await renderExtras(catalog, profile, used);
        bindCartActions();
        updateSelectedBar();
        sendQuizResult();
        root.dispatchEvent(new CustomEvent('miinsecrets:quiz:complete', { bubbles: true, detail: { answers: { ...state.answers } } }));
        if (window.dataLayer && Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'miinsecrets_quiz_complete', quiz_goal: state.answers.goal || 'barrier_or_allergy' });
      } catch (error) {
        if (token !== state.buildToken) return;
        basicHolder.innerHTML = '';
        empty.hidden = false;
      }
    }

    function renderAdvanced(catalog, profile, scores, used) {
      const section = stage.querySelector('[data-advanced-section]');
      const holder = stage.querySelector('[data-advanced-results]');
      const eligibleGoal = ['acne', 'antiage', 'pores'].includes(profile.answers.goal);
      if (!eligibleGoal || profile.flags.noRetinoids || profile.flags.sensitive || profile.flags.barrierOnly || profile.flags.allergy) { section.hidden = true; return; }
      holder.innerHTML = '';

      const serumHandle = root.dataset.retinolSerumCollection;
      const eyeHandle = root.dataset.retinolEyeCollection;
      const ranked = catalog
        .filter((product) => !used.has(product.id) && !isExcluded(product, profile, false, true) && isRetinoid(product))
        .map((product) => ({ product, score: scoreProduct(product, profile, scores) }))
        .filter((item) => item.score >= 4)
        .sort((a, b) => b.score - a.score || a.product.title.localeCompare(b.product.title, 'es'));

      const eyeTerms = /\b(eye|ojos|contorno)\b/;
      const serumTerms = /\b(serum|ampoule|ampolla)\b/;
      const serumCandidate = ranked.find(({ product }) =>
        belongsToCollection(product, [serumHandle]) || (serumTerms.test(productSearchText(product)) && !eyeTerms.test(productSearchText(product)))
      );
      const eyeCandidate = profile.answers.goal === 'antiage' ? ranked.find(({ product }) =>
        product.id !== serumCandidate?.product.id && (belongsToCollection(product, [eyeHandle]) || eyeTerms.test(productSearchText(product)))
      ) : null;

      [
        serumCandidate ? { ...serumCandidate, kind: 'serum' } : null,
        eyeCandidate ? { ...eyeCandidate, kind: 'eye' } : null
      ].filter(Boolean).forEach(({ product, kind }) => {
        used.add(product.id);
        const activeName = /\b(retinal|retinaldehyde)\b/.test(productSearchText(product)) ? 'Retinal' : 'Retinol';
        const card = renderProductCard(product, {
          group: `advanced_${kind}`,
          selected: false,
          selectable: false,
          complete: false,
          essential: false,
          alternative: false,
          reason: kind === 'eye' ? `${activeName} para contorno` : `${activeName} en sérum`,
          category: kind === 'eye' ? 'Tratamiento avanzado · Contorno con retinoide' : 'Tratamiento avanzado · Sérum con retinoide',
          stepDescription: kind === 'eye' ? 'Tratamiento nocturno opcional para el contorno de ojos.' : 'Tratamiento nocturno opcional para tu objetivo principal.'
        });
        if (card) holder.appendChild(card);
      });
      section.hidden = holder.children.length === 0;
    }

    async function renderExtras(catalog, profile, used) {
      const section = stage.querySelector('[data-extras-section]');
      const holder = stage.querySelector('[data-extra-results]');
      holder.innerHTML = '';
      const handles = [root.dataset.deviceOne, root.dataset.deviceTwo].filter(Boolean);
      const deviceProducts = (await Promise.all(handles.map(fetchProduct))).filter(Boolean)
        .filter((product) => isAvailable(product) && !isMiniOrSet(product)).slice(0, 2);
      const makeup = (await fetchCollection(root.dataset.makeupCollection, 24)).map(normaliseProduct).filter(Boolean);
      const makeupProducts = makeup
        .filter((product) => isAvailable(product) && !isMiniOrSet(product) && !isBodyOrHair(product))
        .slice(0, 2);
      const bodyHairRaw = [
        ...(await fetchCollection(root.dataset.bodyCollection, 12)),
        ...(await fetchCollection(root.dataset.hairCollection, 12))
      ];
      const bodyHairMap = new Map();
      bodyHairRaw.map(normaliseProduct).filter(Boolean).forEach((product) => bodyHairMap.set(product.id, product));
      const bodyHairProducts = [...bodyHairMap.values()]
        .filter((product) => isAvailable(product) && !isMiniOrSet(product) && isBodyOrHair(product) && !isExcluded(product, profile, false, false))
        .slice(0, 2);

      const appendGroup = (title, copy, products, reason) => {
        const available = products.filter((product) => !used.has(product.id));
        if (!available.length) return;
        const group = document.createElement('section');
        group.className = 'miiq__extra-group';
        group.innerHTML = `<div class="miiq__extra-heading"><h4>${escapeHtml(title)}</h4><p>${escapeHtml(copy)}</p></div><div class="miiq__products miiq__products--compact"></div>`;
        const grid = group.querySelector('.miiq__products');
        available.forEach((product) => {
          used.add(product.id);
          const card = renderProductCard(product, {
            group: 'extras', selected: false, selectable: false, complete: false, essential: false,
            category: title, reason, stepDescription: 'Se añade individualmente y no forma parte del botón de rutina completa.'
          });
          if (card) grid.appendChild(card);
        });
        if (grid.children.length) holder.appendChild(group);
      };

      appendGroup('💄 Maquillaje coreano', 'Opciones de maquillaje para complementar tu compra.', makeupProducts, 'Maquillaje opcional');
      appendGroup('✨ Accesorios y dispositivos', 'Herramientas adicionales para potenciar la experiencia de cuidado.', deviceProducts, 'Dispositivo opcional');
      appendGroup('🧴 Cuerpo y cabello', 'Productos adicionales para cuidarte de pies a cabeza.', bodyHairProducts, 'Cuidado adicional');
      section.hidden = holder.children.length === 0;
    }

    function bindCartActions() {
      const button = stage.querySelector('[data-add-selected]');
      if (!button) return;
      button.addEventListener('click', async () => {
        const items = [...state.selected.values()].map((item) => ({ id: Number(item.id), quantity: 1 }));
        if (!items.length) return;
        button.disabled = true; button.textContent = 'Agregando tu selección…';
        try {
          await addToCart(items);
          button.textContent = '✓ Selección agregada';
          window.setTimeout(() => { window.location.href = `${rootUrl}cart`; }, 700);
        } catch (error) {
          button.disabled = false; button.textContent = 'Intentar de nuevo'; announce('No pudimos agregar los productos al carrito.');
        }
      });
    }

    back.addEventListener('click', goBack);
    renderScreen('welcome');
    updateProgress('welcome');
  }

  function boot(scope = document) { scope.querySelectorAll('[data-miiq-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();